import React, { useId, useLayoutEffect, useRef, useState } from 'react';

import styles from '../../styles/modules/faq/Faq.module.scss';

const FAQ_ITEMS = [
	{
		id: 1,
		question: 'Что такое "Мини-игра"?',
		answer:
			'Мини-игра - это бесплатная промо активность на сайте, в которой вы можете получать подарки.',
	},
	{
		id: 2,
		question: 'Что такое Battle Pass?',
		answer:
			'Battle Pass - это система вознаграждений за выполнение простых заданий, таких как, например, подписка на соц сети.',
	},
	{
		id: 3,
		question: 'Как получить свой подарок в мини-игре?',
		answer:
			'Просто нажмите на подарок на ленте подарков, игровой персонаж совершит выстрел и вы получите свой подарок',
	},
	{
		id: 4,
		question: 'Что мне даст промо-код?',
		answer:
			'Промокод от блоггера, который позвал тебя в игру, даст тебе +15% к игровому балансу внутренней валюты, не имеющую реальную ценность.',
	},
	{
		id: 5,
		question: 'Что это за сайт?',
		answer:
			'Это сайт игры для быстрого старта. Мы вместе с блоггером решили сделать твой старт в игре удобнее и приятнее!',
	},
];

const FaqList = () => {
	const [openSet, setOpenSet] = useState(() => new Set());

	const toggle = (id) => {
		setOpenSet((prev) => {
			const next = new Set(prev);

			if (next.has(id)) next.delete(id);
			else next.add(id);

			return next;
		});
	};

	return (
		<section className={styles.section}>
			<div className={styles.container}>
				<div className={styles.wrapper}>
					<div className={styles.items}>
						{FAQ_ITEMS.map((item) => (
							<FaqListItem
								key={item.id}
								answer={item.answer}
								question={item.question}
								isOpen={openSet.has(item.id)}
								onToggle={() => toggle(item.id)}
							/>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

const FaqListItem = ({ question, answer, isOpen, onToggle }) => {
	const contentId = useId();

	const innerRef = useRef(null);

	const [height, setHeight] = useState(0);

	useLayoutEffect(() => {
		if (!innerRef.current) return;

		const el = innerRef.current;

		const measure = () => setHeight(el.scrollHeight);

		measure();

		const ro = new ResizeObserver(measure);

		ro.observe(el);

		return () => ro.disconnect();
	}, []);

	return (
		<div className={`${styles.faqListItem} ${isOpen ? styles.isOpen : ''}`}>
			<button
				type='button'
				className={styles.button}
				onClick={onToggle}
				aria-expanded={isOpen}
				aria-controls={contentId}
			>
				<span className={styles.question}>{question}</span>
				<span className={styles.icon} />
			</button>

			<div id={contentId} className={styles.content} style={{ height: isOpen ? height : 0 }}>
				<div ref={innerRef} className={styles.inner}>
					<p className={styles.answer}>{answer}</p>
				</div>
			</div>
		</div>
	);
};

export default FaqList;
